import React from 'react'
import MessageUI from '../../../widgets/output/MessageUI'
import './CreditCardView.css'

const CreditCardViewUI = ({context, messageList, paymentMethodCard}) =>
  <div className='acc_cc_v'>
    <h4 className='name'>{paymentMethodCard.ccBrand}</h4>
    <div className='g_m_top_25'>
      <MessageUI messageList={messageList} messageKey='c_card_ending_with' />:{' '}
      {paymentMethodCard.ccLast4}
    </div>
    <div className='g_m_top_25'>
      <MessageUI messageList={messageList} messageKey='c_card_expiration' />:{' '}
      {paymentMethodCard.ccExpMonth}/{paymentMethodCard.ccExpYear}
    </div>
  </div>

export default CreditCardViewUI
